import { CommonModule } from '@angular/common';
import { Component, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { renderMarkdown } from '../../../utils/MarkdownUtils';

export interface SimulationReportDialogData {
  report: string;
  exportPdf?: () => void | Promise<void>;
}

export const renderSimulationReportMarkdown = renderMarkdown;

@Component({
  selector: 'app-simulation-report-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './simulation-report-dialog.component.html',
  styleUrl: './simulation-report-dialog.component.scss'
})
export class SimulationReportDialogComponent {
  private readonly sanitizer = inject(DomSanitizer);
  readonly data = inject<SimulationReportDialogData>(MAT_DIALOG_DATA);

  readonly reportHtml = this.sanitizer.sanitize(
    SecurityContext.HTML,
    renderSimulationReportMarkdown(this.data.report || '')
  ) || '';

  exportPdf() {
    this.data.exportPdf?.();
  }
}
